<template>
  <div class="pdf-container">
    <div class="pdf-viewer-wrapper">
      <iframe
        :src="pdfSrc"
        class="pdf-iframe"
      ></iframe>
    </div>
    <div class="pdf-download-wrapper">
      <a
        :href="pdfSrc"
        class="btn btn-primary btn-lg pdf-download-btn"
        download
        target="_blank"
      >
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path>
        </svg>
        {{ downloadText }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfViewer',

  props: {
    pdfSrc: {
      type: String,
      required: true
    },
    downloadText: {
      type: String,
      default: 'Download Application Form'
    }
  }
};
</script>
